/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import CreatableSelect from 'react-select/creatable'
import { useFormikContext } from 'formik'
import { RiskProductsContext } from '../../context'
import { InputFieldWithLabel, NumberFieldWithLabel, SelectWithLabel } from '@components/Form/Fields'

export const RiskProductFields = ({ values }) => {
  const { state } = useContext(RiskProductsContext)
  const { formFields } = state

  return (
    formFields.map((field) =>
      <RiskProductField
        key={field.name}
        name={field.name}
        label={field.label}
        value={values[field.name]}
        subLabel={field.subLabel}
        type={field.type}
      />
    )
  )
}

export const RiskProductField = ({ name, label, value, type, subLabel }) => {
  const { state: {
    serviceProviders,
  } } = useContext(RiskProductsContext)

  if (type === 'text') {
    return (
      <InputFieldWithLabel
        name={name}
        label={label}
        subLabel={subLabel}
      />
    )
  } else if (type === 'number') {
    return (
      <NumberFieldWithLabel
        name={name}
        value={value}
        label={label}
        subtext={subLabel}
        placeholder={0}
      />
    )
  } else if (type === 'select') {
    return (
      <Box m='1rem'>
        <SelectWithLabel
          className='app-form__select--service-provider'
          name={name}
          options={serviceProviders}
          label='Service Provider'
          subLabel={subLabel}
        //disabled={!!lastImportedAt}
        />
      </Box>
    )
  } else if (type === 'tags') {
    return (
      <TagsField
        name={name}
        label={label}
        value={value}
        subLabel={subLabel}
      />
    )
  }
}

const toSelectOptions = (values) =>
  (values || []).map((v) => ({ label: v, value: v }))

const fromSelectOptions = (options) =>
  (options || []).map((o) => o.value)

const tagsSelectStyles = {
  control: (base, state) => ({
    ...base,
    background: 'none',
    border: 'none',
    borderBottom: state.isFocused
      ? '1px solid var(--tenant-color-primary)'
      : '1px solid var(--border-color-fields)',
    borderRadius: 0,
    boxShadow: 'none',
    minHeight: '2.625rem',
    transition: 'border-color var(--micro-animation-duration) ease-in-out',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--tenant-color-primary)'
        : 'var(--border-color-fields)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 'var(--size-2px) 0',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: 'var(--space-m)',
    color: 'var(--tenant-color-primary)',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--color-text-inactive)',
    fontSize: 'var(--size-14px)',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'transparent',
    border: '1px solid var(--tenant-color-primary)',
    borderRadius: 'var(--border-radius-fields)',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--tenant-color-primary)',
    fontSize: 'var(--size-14px)',
    padding: 'var(--size-2px) var(--space-xxs)',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--tenant-color-primary)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--tenant-color-primary)',
      color: 'var(--color-white)',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 10,
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
}

const TagsField = ({ name, label, value, subLabel }) => {
  const { setFieldValue } = useFormikContext()
  const inputId = `tags-${name}`

  return (
    <div className='form-field app-form__field'>
      <label htmlFor={inputId}>{label}</label>
      {subLabel && <p className='sublabel'>{subLabel}</p>}
      <CreatableSelect
        inputId={inputId}
        isMulti
        placeholder='Type a name and press enter...'
        value={toSelectOptions(value)}
        onChange={(selected) => setFieldValue(name, fromSelectOptions(selected))}
        noOptionsMessage={() => null}
        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
        styles={tagsSelectStyles}
      />
    </div>
  )
}
